import { SVGProps, Ref, forwardRef } from 'react'
const SvgDocumentEdit = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.63 14.87 15 22.5l-3.75.75.75-3.75 7.63-7.63a2.112 2.112 0 0 1 2.992 0l.008.008a2.112 2.112 0 0 1 0 2.992v0ZM8.25 20.25h-6a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h10.629a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V8.25"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDocumentEdit)
export default ForwardRef
